/* Quotes.tsx
	Une page affichant la gestion des devis clients
	Utilise le composant QuotesCrudCard pour lister, ajouter, gérer et supprimer les éléments
	Utilise l'API correspondante pour les opérations de données
*/

// Import FontAwesome
import { faFileContract } from '@fortawesome/free-solid-svg-icons';

// Import Feature
import { QuotesCrudCard } from 'features/quotes';

// Import Layout
import PageHeader from 'layout/PageHeader';

export const Quotes = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faFileContract}
			title="Devis clients"
			subtitle="Gérez les devis de vos clients"
		/>
		<QuotesCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
